"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _layout = require("./layout.js");

var _TabBar = _interopRequireDefault(require("./TabBar.js"));

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  line-height: 1.625rem;\n\n  padding: 19px 16px 18px;\n  color: ", ";\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n\n  transition: color 0.2s ease, background-color 0.2s ease;\n\n  margin: 0;\n\n  &:hover {\n    color: ", ";\n  }\n\n  &.active {\n    color: ", ";\n\n    &:after {\n      opacity: 1;\n    }\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -1px;\n\n    z-index: 1;\n\n    border: 1px solid ", ";\n    border-radius: 4px;\n\n    opacity: 0;\n    transition: opacity 0.2s ease;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CTab = function (_PureComponent) {
  (0, _chunkB2edacfb.f)(CTab, _PureComponent);

  function CTab() {
    var _getPrototypeOf2;

    var _this;

    (0, _chunkB2edacfb.b)(this, CTab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _chunkB2edacfb.d)(this, (_getPrototypeOf2 = (0, _chunkB2edacfb.e)(CTab)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _chunkB2edacfb.h)((0, _chunkB2edacfb.m)(_this), "onClick", function (onChange) {
      return function (e) {
        var id = _this.props.id;
        onChange && onChange(id, e);
      };
    });
    return _this;
  }

  (0, _chunkB2edacfb.c)(CTab, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          boxProps = (0, _chunkB2edacfb.j)(_this$props, ["id"]);
      return _react.default.createElement(_TabBar.default.Context.Consumer, null, function (_ref) {
        var value = _ref.value,
            onChange = _ref.onChange;
        return _react.default.createElement(StyledTab, (0, _chunkB2edacfb.g)({}, boxProps, {
          className: (0, _classnames.default)(!!id && value === id && "active"),
          onClick: _this2.onClick(onChange)
        }), _this2.props.children);
      });
    }
  }]);
  return CTab;
}(_react.PureComponent);

(0, _chunkB2edacfb.h)(CTab, "displayName", "CTab");
(0, _chunkB2edacfb.h)(CTab, "propTypes", {
  id: _propTypes.default.string
});
CTab.Bar = _TabBar.default;
var StyledTab = (0, _styledComponents.default)(_layout.Box).withConfig({
  displayName: "CTab__StyledTab",
  componentId: "sc-1l8w0h5-0"
})(_templateObject(), function (props) {
  return props.theme["$gray-7"];
}, function (props) {
  return props.theme["$purple"];
}, function (props) {
  return props.theme["$purple"];
}, function (props) {
  return props.theme["$purple"];
});
CTab.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "onChange",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "CTab",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var _default = CTab;
exports.default = _default;